import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import { classNames } from '@utils/classNames.ts';

export function Body2({
  children,
  className,
  ...rest
}: DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>) {
  return (
    <span
      className={classNames(
        'text-base font-normal text-slate-900 block',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
